var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"number"},domProps:{"value":_vm.content},on:{"blur":_vm.handleInput,"focus":function($event){return $event.target.select()}}})}
var staticRenderFns = []

export { render, staticRenderFns }